var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8068_58786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9687 2.53125C14.4883 2.53125 16.9047 3.53214 18.6863 5.31374C20.4679 7.09533 21.4687 9.51169 21.4687 12.0313V12.0313C21.4687 14.5508 20.4679 16.9672 18.6863 18.7488C16.9047 20.5304 14.4883 21.5313 11.9687 21.5313V21.5313C9.44919 21.5313 7.03283 20.5304 5.25124 18.7488C3.46964 16.9672 2.46875 14.5508 2.46875 12.0313V12.0313C2.46875 9.51169 3.46964 7.09533 5.25124 5.31374C7.03283 3.53214 9.44919 2.53125 11.9687 2.53125V2.53125Z",
    fill: "url(#paint0_radial_8068_58786)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9683 3.01127C9.57603 3.01127 7.28176 3.96159 5.59018 5.65317C3.8986 7.34474 2.94828 9.63902 2.94828 12.0313C2.94828 14.4235 3.8986 16.7178 5.59018 18.4094C7.28176 20.101 9.57603 21.0513 11.9683 21.0513C14.3605 21.0513 16.6548 20.101 18.3464 18.4094C20.038 16.7178 20.9883 14.4235 20.9883 12.0313C20.9883 9.63902 20.038 7.34474 18.3464 5.65317C16.6548 3.96159 14.3605 3.01127 11.9683 3.01127ZM4.91136 4.97434C6.78297 3.10273 9.32142 2.05127 11.9683 2.05127C14.6151 2.05127 17.1536 3.10273 19.0252 4.97434C20.8968 6.84596 21.9483 9.38441 21.9483 12.0313C21.9483 14.6781 20.8968 17.2166 19.0252 19.0882C17.1536 20.9598 14.6151 22.0113 11.9683 22.0113C9.32142 22.0113 6.78297 20.9598 4.91136 19.0882C3.03974 17.2166 1.98828 14.6781 1.98828 12.0313C1.98828 9.38441 3.03974 6.84596 4.91136 4.97434Z",
    fill: "url(#paint1_radial_8068_58786)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5195 10.4688C10.5195 10.2037 10.7344 9.98877 10.9995 9.98877H11.9995C12.2646 9.98877 12.4795 10.2037 12.4795 10.4688V16.2813C12.4795 16.5464 12.2646 16.7613 11.9995 16.7613C11.7344 16.7613 11.5195 16.5464 11.5195 16.2813V10.9488H10.9995C10.7344 10.9488 10.5195 10.7339 10.5195 10.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5195 16.4688C10.5195 16.2037 10.7344 15.9888 10.9995 15.9888H12.9995C13.2646 15.9888 13.4795 16.2037 13.4795 16.4688C13.4795 16.7339 13.2646 16.9488 12.9995 16.9488H10.9995C10.7344 16.9488 10.5195 16.7339 10.5195 16.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7495 7.94877C11.9456 7.94877 12.1045 7.78983 12.1045 7.59377C12.1045 7.39771 11.9456 7.23877 11.7495 7.23877C11.5535 7.23877 11.3945 7.39771 11.3945 7.59377C11.3945 7.78983 11.5535 7.94877 11.7495 7.94877ZM11.1445 7.59377C11.1445 7.25964 11.4154 6.98877 11.7495 6.98877C12.0837 6.98877 12.3545 7.25964 12.3545 7.59377C12.3545 7.9279 12.0837 8.19877 11.7495 8.19877C11.4154 8.19877 11.1445 7.9279 11.1445 7.59377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7504 8.21625C12.0942 8.21625 12.3729 7.93755 12.3729 7.59375C12.3729 7.24996 12.0942 6.97125 11.7504 6.97125C11.4066 6.97125 11.1279 7.24996 11.1279 7.59375C11.1279 7.93755 11.4066 8.21625 11.7504 8.21625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8068_58786",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8031 34.1188) rotate(-123.819) scale(43.9523 110.342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#007C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8068_58786",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5017 35.2348) rotate(-123.819) scale(46.1731 115.918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#007C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8068_58786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.57bf907a328906cae24c16d9cb2ae73d.svg";
export { ForwardRef as ReactComponent };